export const calculateOffset = () => {
  try {
    const telegramWebApp = (window as any).Telegram?.WebApp;
    
    let isMobile = false;
    
    if (telegramWebApp) {
      const platform = telegramWebApp.platform;
      isMobile = platform === 'ios' || platform === 'android';
    } else {
      const ua = navigator.userAgent.toLowerCase();
      isMobile = /android|iphone|ipad|ipod/i.test(ua);
    }
    
    const safeAreaHeightRem = isMobile ? 5.625 : 1.5;
    const logoTopRem = isMobile ? 3.62 : 1.5;
    
    document.documentElement.style.setProperty('--safe-area-height', `${safeAreaHeightRem}rem`);
    document.documentElement.style.setProperty('--logo-top', `${logoTopRem}rem`);
    /**
    console.log('[safeArea] Safe zone установлена:', {
      isMobile,
      safeAreaHeight: `${safeAreaHeightPx}px`,
      platform: telegramWebApp?.platform || 'unknown'
    });
    */
  } catch (error) {
    console.error('[safeArea] Ошибка при вычислении safe zone:', error);
    document.documentElement.style.setProperty('--safe-area-height', '20px');
  }
};